import { useHotkeys } from "@mantine/hooks";
import { Button } from "@win-reality/react-ui";
import { useDispatch, useSelector } from "react-redux";

import { incrementTaggingFlowStep } from "../../../../store/slices/hotkeys";
import { putTag, removeTag } from "../../../../store/slices/session";
import type { RootState } from "../../../../store/store";

/**
 * PrePitchStep - Select pitcher's pre-pitch stance
 *
 * Options:
 * - Windup (W)
 * - Stretch (S)
 */
export const PrePitchStep = () => {
  const tagData = useSelector((state: RootState) => state.session.tagData);
  const dispatch = useDispatch();
  const tagKey = "prePitchStance";

  function handleTag(value: string) {
    if (tagData[tagKey] === value) {
      dispatch(removeTag({ key: tagKey }));
    } else {
      dispatch(putTag({ key: tagKey, value }));
      dispatch(incrementTaggingFlowStep());
    }
  }

  const hotkeys = {
    Windup: "W",
    Stretch: "S",
  };

  useHotkeys([
    [hotkeys.Windup, () => handleTag("Windup")],
    [hotkeys.Stretch, () => handleTag("Stretch")],
  ]);

  return (
    <div className="flex w-full flex-col items-center gap-0">
      {/* Instructions */}
      <div className="flex h-10 items-center justify-center">
        <p className="text-sm italic text-text-light">
          Select Pre Pitch Stance
        </p>
      </div>

      {/* Windup Button */}
      <div className="flex h-10 w-3/4 items-center justify-center">
        <Button
          variant={tagData[tagKey] === "Windup" ? "blue" : "ghost"}
          onClick={() => handleTag("Windup")}
          size="sm"
          className="w-full normal-case border border-gray-300"
        >
          <span className="flex items-center justify-between w-full">
            Windup
            <kbd className="ml-2 rounded bg-[hsla(218,100%,52%,0.1)] px-2 py-1 text-xs font-semibold">
              {hotkeys.Windup}
            </kbd>
          </span>
        </Button>
      </div>

      {/* Stretch Button */}
      <div className="flex h-10 w-3/4 items-center justify-center">
        <Button
          variant={tagData[tagKey] === "Stretch" ? "blue" : "ghost"}
          onClick={() => handleTag("Stretch")}
          size="sm"
          className="w-full normal-case border border-gray-300"
        >
          <span className="flex items-center justify-between w-full">
            Stretch
            <kbd className="ml-2 rounded bg-[hsla(218,100%,52%,0.1)] px-2 py-1 text-xs font-semibold">
              {hotkeys.Stretch}
            </kbd>
          </span>
        </Button>
      </div>
    </div>
  );
};
